import React from 'react';
import './Loading.scss';

const Loader = props => {
  const { context } = props;
  return (
    <div context={context} className={`loader-wrap ${context}`}>
      {context !== 'Markdown' && (
        <div className="loading-spinner loading-spinner--indigo">
          <div className="wrapper">
            <div className="wheel" />
          </div>
        </div>
      )}
      {context === 'Markdown' && (
        <div className="faux-header">
          <div className="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Loader;
